import { MessageHelper } from "../helper/message-helper";
import { Logger } from "../logger/logger";

export class Copy {
	public static readonly copyTextToClipboard = (text: string): boolean => {
		let textArea = document.createElement("textarea");
		textArea.style.position = "fixed";
		textArea.style.top = "0";
		textArea.style.left = "0";
		textArea.style.width = "2em";
		textArea.style.height = "2em";
		textArea.style.padding = "0";
		textArea.style.border = "none";
		textArea.style.outline = "none";
		textArea.style.boxShadow = "none";
		textArea.style.background = "transparent";
		textArea.value = text;
		document.body.appendChild(textArea);
		textArea.select();
		let successful = false;
		try {
			successful = document.execCommand("copy");
		} catch (err) {
			Logger.error(err);
		}

		document.body.removeChild(textArea);
		return successful;
	}

	public static readonly copyTextToClipboardWithMessage = (text: string,
		successText: string = "Die Daten wurden erfolgreich in die Zwischenablage kopiert",
		errorText: string = "Die Daten konnten nicht in die Zwischenablage kopiert werden"): boolean => {
		let result = Copy.copyTextToClipboard(text);
		if (result) {
			MessageHelper.uiSuccess(successText);
		} else {
			MessageHelper.uiError(errorText);
		}
		return result;
	}
}